exports.Deflater = require("./deflater");
exports.Inflater = require("./inflater");


//////////////////
// WEBPACK FOOTER
// ./~/adm-zip/methods/index.js
// module id = 516
// module chunks = 0